import { Ionicons } from "@expo/vector-icons";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Pressable, Text, View } from "react-native";

interface CardAccountProps {
  onPress: () => void;
}

export default function CardAddAccount(props: CardAccountProps) {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Pressable
      className="bg-white1 flex-col h-40 w-40 rounded-lg p-2 mt-1 lg:mt-0 lg:h-48 lg:w-48 transition duration-200 hover:shadow-md shadow overflow-hidden relative"
      onHoverIn={() => setIsHovered(true)}
      onHoverOut={() => setIsHovered(false)}
      onPress={props.onPress}
    >
      <View className="flex-row items-end justify-end absolute top-0 left-0 right-0 p-4">
        {isHovered ? (
          <View className="flex-row items-center justify-center rounded-full bg-purple1 h-8 w-8 justify-center overflow-hidden shadow">
            <Ionicons
              name="add-outline"
              color="#fff"
              fontWeight="bold"
              size={20}
            />
          </View>
        ) : (
          <View className="flex-row items-center justify-center rounded-full bg-white h-8 w-8 justify-center overflow-hidden shadow">
            <Ionicons name="add-outline" color="#000000" size={20} />
          </View>
        )}
      </View>
      <View className="flex-grow items-center justify-center">
        <Text className="font-normal text-xl">
          {t("home/home:card.addaccount")}
        </Text>
      </View>
    </Pressable>
  );
}
